module.exports = __webpack_public_path__ + "workspace/static/img/notificationCenterThree.a21b685.png";